export default __webpack_public_path__ + "static/media/3.658b3f6a.png";